<template src= "./detail.html"></template>

<script>
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'
import agTableComp from '@/optionData/agTableComp'
import {ko} from 'vuejs-datepicker/dist/locale'






// 

export default {
    name: 'artistList',
    
    data () {
        return {
            test : false, 
            ko : ko,
            startDate :null,
            endDate : null,
            myDataTable : [{}],
            optionData : optionData, 
         
            stateLabel : {
                'data_loading' : '데이터 로딩중',
                'validation_incomplete' :  '검수 가능',
                'validation_processing' :  '검수 처리중',
                'validation_complete' :  '검수 완료',
                'deposit_processing' : `기준 화폐 환전 처리 중`,
                'deposit_complete' : '기준 화폐 환전 완료',
                'exchange_complete' : '2차 환전 완료',
                'open_complete' : '정산공개 완료'
            },
            stateList : [
                'data_loading',
                'validation_incomplete',
                'validation_processing',
                'validation_complete',
                'deposit_processing',
                'deposit_complete',
                'exchange_complete',
                'open_complete',
            ],
            salesData :{
                aggregator_name: "IIP-DDS B.V. (FUGA)",
                error_count: 47619,
                error_percentage: 73.62244897959184,
                salesline_count: 64680,
                // 체크 순서 
                count_format_startdate_error: 0,//
                count_format_enddate_error: 0, //
                count_format_hitcount_error: 0,
                count_format_amount_error: 0, // 
                count_format_country_error: 0, //
                count_format_currency_error: 0, // 
                count_musicstore_error: 0, //
                count_service_error: 0, ///
                count_track_code_error: 0, // 
                count_album_code_error: 0,//
                count_track_name_error: 0, //
                count_album_name_error: 0, //
            },
            

            list :{
                data :[
                    { occurrance : 33, hitcount :'ss' },
                    { occurrance : 33, hitcount :'ss' },
                    { occurrance : 33, hitcount :'ss' },
                    { occurrance : 33, hitcount :'ss' },
                    { occurrance : 33, hitcount :'ss' },
                    { occurrance : 33, hitcount :'ss' },
                   
                ],
                currentPage:1,
                pageSize: 50,
                totalPage : 0,
                columnDefs: [
                    {headerName: '오류 발생수', field: 'occurrance', filter: false,width: 150, },
                    {headerName: '오류값', field: 'hitcount', filter: false,width: 200,
                    cellRendererSelector: (data) => {
                        let dd={
                            component: 'textRender',
                            params: {
                                ...data.data,
                                text : data.value
                            }
                        } ;
                        
                        return dd
                    }},
                    {headerName: '수정값', field: '', filter: false,width: 350,
                    cellRendererParams: {
                        clicked: (data) => {
                            console.log(data)
                        }
                    },
                    cellRendererSelector: (data) => {
                        let dd={
                            component: 'textInput',
                            params: {
                                ...data.data,
                            }
                        } ;
                        
                        return dd
                    }},
                ],
                gridOptions :{
                    context: {
                        componentParent: this
                    },
                    onGridReady: function (event) {
                    },
                    onRowClicked: (event)=>{
                    },
                    frameworkComponents :agTableComp,
                    
                    tabToNextCell:false,
                    navigateToNextCell:false,
                    suppressCellSelection : false,
                    // getRowHeight:(params)=>{
                    //     return 47
                    // }
                }
            },
            errorName : null,

            operationList : [],
            cellOptionList  : [],
            operateName : null,
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage= Number(this.$route.query.page)
        }
        
    },
    mounted(){
        this.$nextTick(() =>{
            this.call()
        })
    },
    computed: {
        count_format_startdate_error(){
            if(
                this.test ||
                this.salesData.count_format_startdate_error != 0 ){
                return true   
            }else{
                return false
            }
        },
        count_format_enddate_error(){
            if(
                this.test ||
                this.salesData.count_format_enddate_error != 0 &&
                this.salesData.count_format_startdate_error == 0 ){
                return true   
            }else{
                return false
            }
        },
        count_format_hitcount_error(){
            if(
                this.test ||
            this.salesData.count_format_hitcount_error != 0 &&
            this.salesData.count_format_startdate_error == 0 &&
            this.salesData.count_format_enddate_error == 0 ){
                return true   
            }else{
                return false
            }
        },
        count_format_amount_error(){ 
            if(
            this.salesData.count_format_amount_error != 0 && 
            this.salesData.count_format_startdate_error == 0 &&
            this.salesData.count_format_enddate_error == 0 &&
            this.salesData.count_format_hitcount_error == 0 
            ){
                return true   
            }else{
                return false
            }
        },
        count_format_country_error(){ 
            if(
            this.salesData.count_format_country_error != 0 &&
            this.salesData.count_format_startdate_error == 0 &&
            this.salesData.count_format_enddate_error == 0 &&
            this.salesData.count_format_hitcount_error == 0 &&
            this.salesData.count_format_amount_error == 0  ){
                return true   
            }else{
                return false
            }
        },
        count_format_currency_error(){ 
            if(
                this.test ||
            this.salesData.count_format_currency_error != 0 &&
            this.salesData.count_format_startdate_error == 0 &&
            this.salesData.count_format_enddate_error == 0 &&
            this.salesData.count_format_hitcount_error == 0 &&
            this.salesData.count_format_amount_error == 0 &&
            this.salesData.count_format_country_error == 0 ){
                return true   
            }else{
                return false
            }
        },
        count_musicstore_error(){ 
            if(
            this.test ||
            this.salesData.count_musicstore_error != 0 &&
            this.salesData.count_format_startdate_error == 0 &&
            this.salesData.count_format_enddate_error == 0 &&
            this.salesData.count_format_hitcount_error == 0 &&
            this.salesData.count_format_amount_error == 0 &&
            this.salesData.count_format_country_error == 0 &&
            this.salesData.count_format_currency_error == 0 ){
                return true   
            }else{
                return false
            }
        },
        count_service_error(){ 
            if(
                this.test ||
            
            this.salesData.count_service_error != 0 &&
            this.salesData.count_format_startdate_error == 0 &&
            this.salesData.count_format_enddate_error == 0 &&
            this.salesData.count_format_hitcount_error == 0 &&
            this.salesData.count_format_amount_error == 0 &&
            this.salesData.count_format_country_error == 0 &&
            this.salesData.count_format_currency_error == 0 &&
            this.salesData.count_musicstore_error == 0  ){
                return true   
            }else{
                return false
            }
        },
        count_track_code_error(){
            if(
                this.test ||
            this.stateList.indexOf(this.salesData.state) > -1 &&
            this.stateList.indexOf(this.salesData.state) < 3 &&
            // this.salesData.count_track_code_error != 0 &&
            this.salesData.state != 'validation_processing' &&
            this.salesData.count_format_startdate_error == 0 &&
            this.salesData.count_format_enddate_error == 0 &&
            this.salesData.count_format_hitcount_error == 0 &&
            this.salesData.count_format_amount_error == 0 &&
            this.salesData.count_format_country_error == 0 &&
            this.salesData.count_format_currency_error == 0 &&
            this.salesData.count_musicstore_error == 0 &&
            this.salesData.count_service_error == 0 ){
                return true   
            }else{
                return false
            }
        },
        count_album_code_error(){ 
            if(
            //this.salesData.count_album_code_error != 0 &&
            this.test ||
            this.stateList.indexOf(this.salesData.state) > -1 &&
            this.stateList.indexOf(this.salesData.state) < 3 &&
            this.salesData.state != 'validation_processing' &&
            this.salesData.count_format_startdate_error == 0 &&
            this.salesData.count_format_enddate_error == 0 &&
            this.salesData.count_format_hitcount_error == 0 &&
            this.salesData.count_format_amount_error == 0 &&
            this.salesData.count_format_country_error == 0 &&
            this.salesData.count_format_currency_error == 0 && 
            this.salesData.count_musicstore_error == 0 &&
            this.salesData.count_service_error == 0 
            
            // this.salesData.count_track_code_error == 0  
            ){
                return true   
            }else{
                return false
            }
        },
        count_track_name_error(){ 
            if(
                this.test ||
            this.stateList.indexOf(this.salesData.state) > -1 &&
            this.stateList.indexOf(this.salesData.state) < 3 &&
                this.salesData.state != 'validation_processing' &&
            // this.salesData.count_track_name_error != 0 &&
            this.salesData.count_format_startdate_error == 0 &&
            this.salesData.count_format_enddate_error == 0 &&
            this.salesData.count_format_hitcount_error == 0 &&
            this.salesData.count_format_amount_error == 0 &&
            this.salesData.count_format_country_error == 0 &&
            this.salesData.count_format_currency_error == 0 &&
            this.salesData.count_musicstore_error == 0 &&
            this.salesData.count_service_error == 0
            // this.salesData.count_track_code_error == 0 &&
            // this.salesData.count_album_code_error == 0 
            ){
                return true   
            }else{
                return false
            }
        },
        count_album_name_error(){
            if(
            this.test ||
            this.stateList.indexOf(this.salesData.state) > -1 &&
            this.stateList.indexOf(this.salesData.state) < 3 &&
            this.salesData.state != 'validation_processing' &&
            this.salesData.count_format_startdate_error == 0 &&
            this.salesData.count_format_enddate_error == 0 &&
            this.salesData.count_format_hitcount_error == 0 &&
            this.salesData.count_format_amount_error == 0 &&
            this.salesData.count_format_country_error == 0 &&
            this.salesData.count_format_currency_error == 0 &&
            this.salesData.count_musicstore_error == 0 &&
            this.salesData.count_service_error == 0 
            
            // this.salesData.count_track_code_error == 0 &&
            // this.salesData.count_album_code_error == 0 &&
            // this.salesData.count_track_name_error == 0
            ){
                return true   
            }else{
                return false
            }
        },
        

        
       
    },
    watch: {
        'list.currentPage'(e){
            
            this.errorList(this.errorName)
        },
        'list.pageSize'(){
            this.list_search()
        }
    },
    methods: {
        
        call(){
            
            let payload = {
                id : `${this.$route.params.id}`
            }
            
            this.loadingShow()

            this.$store.dispatch('GET_SALESLINEGROUP_ITEM', payload)
            .then(result =>{
                this.loadingHide()
                if(result.length != 0){
                    this.salesData ={
                        ...result[0]
                    }
                }else{
                    this.noti('검수중입니다.')
                    this.historyBack()
                }
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        errorPop(name){
            if(this.valCheck(name)){
                this.alert({msg:'에러 대상을 찾지 못했습니다.'});
                return false
            }
           switch(name){
               case 'track-code':
                    this.$router.push('/dataUpload/detail/'+this.$route.params.id+'/codetrack').catch(() => {})
                    break;
                case 'album-code':
                    
                    this.$router.push('/dataUpload/detail/'+this.$route.params.id+'/codealbum').catch(() => {})
                    break;
                case 'track-name':
                    this.$router.push('/dataUpload/detail/'+this.$route.params.id+'/nametrack').catch(() => {})
                    break;
                case 'album-name':
                    this.$router.push('/dataUpload/detail/'+this.$route.params.id+'/namealbum').catch(() => {})
                    break;
                 default:
                    this.list.currentPage = 1
                    this.tableSet(name)
                    this.errorList(name)
                break;
           }
            
        },
        errorList(name){
            let payload = {
                id : `${this.$route.params.id}`,
                params : {
                    error : name,
                    page: this.list.currentPage-1 ,
                    limit: this.list.pageSize,
                }
            }
            
            this.loadingShow()
            this.$store.dispatch('GET_SALESLINEGROUP_ITEM_ERROR', payload)
            .then(result =>{
                console.log(result)
                this.errorName = name
                if(this.test){
                    this.list.data = [
                   {
                        country: null,
                        occurrance: 10321,
                        validation_error: "FORMAT_COUNTRY_ERROR",
                        validation_state: "ERROR",
                    },{
                        country: null,
                        occurrance: 10321,
                        validation_error: "FORMAT_COUNTRY_ERROR",
                        validation_state: "ERROR",
                    },{
                        country: null,
                        occurrance: 10321,
                        validation_error: "FORMAT_COUNTRY_ERROR",
                        validation_state: "ERROR",
                    },{
                        country: null,
                        occurrance: 10321,
                        validation_error: "FORMAT_COUNTRY_ERROR",
                        validation_state: "ERROR",
                    },{
                        country: null,
                        occurrance: 10321,
                        validation_error: "FORMAT_COUNTRY_ERROR",
                        validation_state: "ERROR",
                    },
                ]
                }else{
                    this.list.data  = result.items // 권리자 목록
                }
                
                
                this.total = result.total // 총인원수 
                this.filtered = result.filtered // limit에 따른 수
                //페이지 수
                const remainder = parseInt(this.filtered % this.list.pageSize) > 0? 1: 0
                this.list.totalPage = parseInt(this.filtered/this.list.pageSize) + remainder
                setTimeout(() => {
                    this.openModal(name)
                    this.loadingHide()    
                }, 300);
                
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        errorPut(name,data){
            let payload = {
                id : `${this.$route.params.id}`,
                type : name,
                params : {
                  
                }
            }
            let obj = {}
            console.log(name,data)
            switch (name.toLowerCase()) {
                case 'format-startdate':
                    obj= {
                        old : data.service_start_date ,
                        new : data.editValue 
                    }
                    payload.params = [obj]
                    break;
                case 'format-enddate':
                     obj = {
                        old : data.service_end_date ,
                        new : data.editValue 
                    }
                    payload.params = [obj]
                    break;
                case 'format-hitcount':
                    obj= {
                        old : data.hitcount ,
                        new : Number(data.editValue) 
                    }
                    payload.params = [obj]
                    break;
                case 'format-amount':
                     obj= {
                        old : data.amount ,
                        new : Number(data.editValue)
                    }
                    payload.params = [obj]
                    break;
                case 'format-country':
                     obj= {
                        old : data.country ,
                        new : data.editValue 
                    }
                    payload.params = [obj]
                    break;
                case 'format-currency':
                    
                    obj= {
                        old : data.currency ,
                        new : data.editValue 
                    }
                    payload.params = [obj]
                    break;
                case 'musicstore':
                    obj= {
                       
                        "musicstore_name": data.musicstore_name,
                        "display_name": data.display_name,
                        "operator_id": data.operation,
                        "group": data.group,
                        "active": data.active
                    }
                    payload.params = [obj]
                    
                    break;
                case 'service':
                    obj = {
                        "musicstore_id": data.musicstore_id,
                        "name": data.service_name,
                        "code": data.service_code,
                        "type": data.optionValue
                    }
                    payload.params = [obj]
                    break;
                case 'track-code':
                    
                    break;
                case 'album-code':
                    break;
                case 'track-name':
                    break;
                case 'album-name':
                    break;
            }
            
            this.loadingShow()
            this.$store.dispatch('PUT_ITEM_ERROR', payload)
            .then(result =>{
                this.loadingHide()
                this.errorList(name)
                

            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        tableSet(name){
            switch (name.toLowerCase()) {
                case 'format-startdate':
                    this.list.columnDefs = [
                        {headerName: '오류 발생수', field: 'occurrance', filter: false,width: 100, },
                        {headerName: '오류값', field: 'service_start_date', filter: false,width: 250, cellRendererSelector: (data) => {
                            let dd={
                                component: 'textRender',
                                params: {
                                    ...data.data,
                                    text: data.value,
                                    style: 'font-size:13px;'
                                }
                            } ;
                            
                            return dd
                        }},
                        {headerName: 'yyyy-mm-dd', field: '', filter: false,width: 350,
                            cellClass : "visibleBox",
                            cellRendererParams: {
                            clicked: (data,index) => {
                                this.errorPut('format-startdate',data)
                            }
                            },
                            cellRendererSelector: (data) => {
                                let dd={
                                    component: 'dateSelect',
                                    params: {
                                        ...data.data,
                                    }
                                } ;
                                
                                return dd
                            }
                        },
                    ]
                    break;
                case 'format-enddate':
                    this.list.columnDefs = [
                        {headerName: '오류 발생수', field: 'occurrance', filter: false,width: 100, },
                        {headerName: '오류값', field: 'service_end_date', filter: false,width: 250, cellRendererSelector: (data) => {
                            let dd={
                                component: 'textRender',
                                params: {
                                    ...data.data,
                                    text: data.value,
                                    style: 'font-size:13px;'
                                }
                            } ;
                            
                            return dd
                        }},
                        {headerName: 'yyyy-mm-dd', field: '', filter: false,width: 350,
                        cellClass : "visibleBox",
                        cellRendererParams: {
                            clicked: (data) => {
                               this.errorPut('format-enddate',data)
                            }
                        },
                            cellRendererSelector: (data) => {
                                let dd={
                                    component: 'dateSelect',
                                    params: {
                                        ...data.data,
                                    }
                                } ;
                                
                                return dd
                        }},
                    ]
                    break;
                case 'format-hitcount':
                    this.list.columnDefs = [
                        {headerName: '오류 발생수', field: 'occurrance', filter: false,width: 100, },
                        {headerName: '오류값', field: 'hitcount', filter: false,width: 250, cellRendererSelector: (data) => {
                            let dd={
                                component: 'textRender',
                                params: {
                                    ...data.data,
                                    text: data.value,
                                    style: 'font-size:13px;'
                                }
                            } ;
                            
                            return dd
                        }},
                        {headerName: '숫자(소수점제외)', field: '', filter: false,width: 350,
                            cellRendererParams: {
                                clicked: (data) => {
                                    this.errorPut('format-hitcount',data)
                                }
                            },
                            cellRendererSelector: (data) => {
                                let dd={
                                    component: 'textInput',
                                    params: {
                                        ...data.data,
                                    }
                                } ;
                                
                                return dd
                        }},
                    ]
                    break;
                case 'format-amount':
                    this.list.columnDefs = [
                            {headerName: '오류 발생수', field: 'occurrance', filter: false,width: 100, },
                            {headerName: '오류값', field: 'amount', filter: false,width: 250, cellRendererSelector: (data) => {
                                let dd={
                                    component: 'textRender',
                                    params: {
                                        ...data.data,
                                        text: data.value,
                                        style: 'font-size:13px;'
                                    }
                                } ;
                                
                                return dd
                            }},
                            {headerName: '숫자', field: '', filter: false,width: 350,cellRendererParams: {
                                clicked: (data) => {
                                    this.errorPut('format-amount',data)
                                }},
                                cellRendererSelector: (data) => {
                                    let dd={
                                        component: 'textInput',
                                        params: {
                                            ...data.data,
                                        }
                                    } ;
                                    
                                    return dd
                                }
                            },
                    ]
                    break;
                case 'format-country':
                    this.list.columnDefs = [
                            {headerName: '오류 발생수', field: 'occurrance', filter: false,width: 100, },
                            {headerName: '오류값', field: 'country', filter: false,width: 250, 
                            cellClass : "visibleBox",
                            cellRendererSelector: (data) => {
                                let dd={
                                    component: 'selectBoxCountry',
                                    params: {
                                        ...data.data,
                                        code: data.value,
                                        style: 'font-size:13px; ',
                                        disabled : true
                                    }
                                } ;
                                return dd
                            }},
                            {headerName: '국가', field: '', filter: false,width: 350,
                                cellClass : "agOverflow",
                                cellRendererParams: {
                                    clicked: (data) => {
                                        this.errorPut('format-country',data)
                                    }
                                },
                                cellRendererSelector: (data) => {
                                    let dd={
                                        component: 'selectBoxCountry',
                                        params: {
                                            ...data.data,
                                        }
                                    } ;
                                            
                                    return dd
                                }
                            },
                    ]
                    break;
                case 'format-currency':
                    this.list.columnDefs = [
                            {headerName: '오류 발생수', field: 'occurrance', filter: false,width: 100, },
                            {headerName: '오류값', field: 'curren', filter: false,width: 250, 
                            cellClass : "visibleBox",
                            cellRendererSelector: (data) => {
                                this.cellOptionList  = [
                                    {value: 'krw', label: 'KRW 한국 원화'},
                                    {value: 'usd', label: 'USD 미국 달러화'},
                                    {value: 'eur', label: 'EUR 유럽 유로화'},
                                    {value: 'cny', label: 'CNY 중국 위안화 '},
                                ]
                                let dd={
                                    component: 'selectBox',
                                    params: {
                                        ...data.data,
                                        code: data.value,
                                        style: 'font-size:13px;',
                                        disabled : true,
                                        
                                    }
                                } ;
                                
                                return dd
                            }},
                            
                            {headerName: '화폐단위', field: '', filter: false,width: 350,
                                cellClass : "visibleBox",
                                cellRendererParams: {
                                    clicked: (data) => {
                                        this.errorPut('format-currency',data)
                                    }
                                },
                                cellRendererSelector: (data) => {
                                    let dd={
                                        component: 'selectBox',
                                        params: {
                                            ...data.data,
                                            optionList : [
                                                {value: 'krw', label: 'KRW 한국 원화'},
                                                {value: 'usd', label: 'USD 미국 달러화'},
                                                {value: 'eur', label: 'EUR 유럽 유로화'},
                                                {value: 'cny', label: 'CNY 중국 위안화 '},
                                            ]
                                        }
                                    } ;
                                            
                                    return dd
                                }
                            },
                    ]
                    
                    break;
                case 'musicstore':
                    setTimeout(() => {
                        this.operationCall();    
                    }, 1000);
                    
                    this.list.columnDefs = [
                            {headerName: '오류 발생수', field: 'occurrance', filter: false,width: 100, resizable:true,},
                            {headerName: '로그 뮤직스토어', field: 'musicstore_name', filter: false,width: 200,resizable:true,},
                            {headerName: '운영사 / 유통그룹 / 유통상태 / 뮤직스토어(Display)', field: '', filter: false,width: 660,resizable:true, 
                            cellClass : "visibleBox",
                            cellRendererParams: {
                                clicked: (data) => {
                                    this.errorPut('musicstore',data)
                                }},
                                cellRendererSelector: (data) => {
                                    let dd={
                                        component: 'musicStore',
                                        params: {
                                            ...data.data,
                                        }
                                    } ;
                                    return dd
                                }
                            },
                            
                            
                    ]
                    break;
                case 'service':
                    this.list.columnDefs = [
                        
                        {headerName: '오류 발생수', field: 'occurrance', filter: false,width: 100, resizable:true,},
                        {headerName: '뮤직스토어', field: 'musicstore_name', filter: false,width: 200, resizable:true,},
                        {headerName: '서비스코드', field: 'service_code', filter: false,width: 150, resizable:true,},
                        {headerName: '서비스명', field: 'service_name', filter: false,width: 400, resizable:true,},
                        {headerName: '서비스 선택', field: '', filter: false,width: 350,
                            cellClass : "agOverflow",
                            cellRendererParams: {
                                clicked: (data) => {
                                    this.errorPut('service',data)
                                }
                            },
                            cellRendererSelector: (data) => {
                                let dd={
                                    component: 'serviceBtn',
                                    params: {
                                        ...data.data,
                                    }
                                        } ;
                                        
                                return dd
                            }
                        },
                    ]
                    break;
                case 'track-code':
                    
                    break;
                case 'album-code':
                    break;
                case 'track-name':
                    break;
                case 'album-name':
                    break;
            }
        },
        

        operationCall(){
            if(this.valCheck(this.salesData.aggregator_id)){
                this.alert({msg:'계약사가 존재 하지않습니다. 개발팀에게 문의해주세요.'})
                return false
            }
            let payload = {
                id : `${this.salesData.aggregator_id}`,
                params : {
                    page: 0 ,
                    limit: 100,
                }
            }
            
            this.loadingShow()
            this.$store.dispatch('GET_OPERATE_LIST', payload)
            .then(result =>{
                this.loadingHide()    
                console.log(result)
                this.errorName = name
                this.operationList  = result.items 
                this.cellOptionList  = result.items
                
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        
        storeList(id){
            const option = {
                sort: 'created_at',
                sortorder: 'desc',
                page: 0,
                limit: 500,
                operator_id : id
                //is_various_artists: false, // 필수 filter
            }
            this.$store.dispatch('GET_MUSICSTORE', option)
            .then(result =>{
                this.loadingHide()
                this.storeList  = [
                    {name : '전체', id : null},
                    ...result.items
                ]
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        saveOperate(){
            if(this.valCheck(this.operateName)){
                this.alert({msg:'운영사 명을 입력해주세요.'})
                return false
            }
            let payload = {
                id : `${this.salesData.aggregator_id}`,
                params : {
                    name : this.operateName
                }
            }
            
            this.loadingShow()
            this.$store.dispatch('saveOperate', payload)
            .then(result =>{
                this.loadingHide()    
                this.noti('운영사 추가를 성공하였습니다.')
                this.closeModal('operate')
                this.operationCall()
                this.operateName = null
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        postValidate(){
            let payload = {
                id : `${this.$route.params.id}`,
                
            }
            this.loadingShow()
            this.$store.dispatch('POST_SALES_VALIDADATE', payload)
            .then(result =>{
                setTimeout(() => {
                    this.loadingHide()
                    this.call()    
                }, 1000);
                
                

            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
